import { Directive, ElementRef, Renderer2, OnInit, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[proBadge]'
})
export class SubscriptionWidgetDirective implements OnInit {
  @Input() show: boolean = false; // Default to false if not provided

  constructor(private el: ElementRef, private renderer: Renderer2) { }



  ngOnInit(): void {

    if (this.show) {
      const badge = this.renderer.createElement('span');
      this.renderer.addClass(badge, 'pro-badge');
      const crownIcon = this.renderer.createElement('img');
      this.renderer.setAttribute(crownIcon, 'src', '../../../assets/subscription/crown.svg');
      this.renderer.appendChild(badge, crownIcon);
      // this.renderer.appendChild(badge, document.createTextNode('Songdew Pro'));

      this.renderer.appendChild(this.el.nativeElement, badge);

    }
  }

}
